<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2003</span></div>
    </div>
    <div class="view-wrap yr2003">


<FullYearStats fullGames='11' fullCompletions='205' fullAttempts='356' fullYards='2,108' fullPct='57.6' fullTDs='11' fullINTs='15' fullYPG='191.6' fullRating='67.5'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
     
      <div class="year-summary-text-flex">
 <h1 class="content-headline">San Diego's Quarterback Carousel</h1>

      <p class="image-paragraph">Expectations were high as the Chargers were trending in the right direction after going 1-15, 5-13, and 8-8 in their previous three seasons. Unfortunately 2003 brought a quarterback carousel to San Diego. Brees was benched three times for Doug Flutie over the course of the season and the Chargers would finish the season 4-12.<br/><br/>
      Brees had to swallow the bitter pill of watching the game from the sideline. "That's reality," Brees said, "...that's life. If you're not getting the job done you're not gonna play."<br/><br/>

      Brees took his lumps in the best way possible as he focused on learning the offense in greater detail to ultimately help his team win games. Remembering his sideline stint, Brees said,"I learned so much that when I stepped back out there I felt like a different person and a different player."<br/><br/>
      </p>

      <p>
      
      
<img src="../assets/brees-2003-1.jpg" class="img-100w" alt="Drew Brees being coached up by Marty Schottenheimer with Doug Flutie in the background">
      </p>


      </div> <!--end text-flex-->
    </div>
  </div>



<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2003 Touchdown Tally"> 2003 TOUCHDOWN TALLY</h1>
</div>



</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2003 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2003 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2003 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2003 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2003 - Slide5"></div>
</flickity>

<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2002">«2002</router-link></div>
  <div class="year-pagination-section year-pagination-current">2003</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2004">2004»</router-link></div>
</div>

    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';

import axios from 'axios';

export default {
  name: 'yr2003',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2003 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2003-top.jpg",
      image1: "brees-2003-slide-1.jpg",
      image2: "brees-2003-slide-2.jpg",
      image3: "brees-2003-slide-3.jpg",
      image4: "brees-2003-slide-4.jpg",
      image5: "brees-2003-slide-5.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2003;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

}
}
</script>

<style>



</style>


// WEBPACK FOOTER //
// src/views/yr2003.vue